import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeIcon } from './mixins';
import spriteUrl from '../../assets/icons/sprite.svg';
const I = styled.i `
  ${(props) => makeIcon(props)}
`;
export const Icon = (props) => {
    const { name } = props;
    return React.createElement(I, Object.assign({ className: `icon-${name}` }, props, { source: spriteUrl }));
};
Icon.propTypes = {
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
    size: PropTypes.string,
};
Icon.defaultProps = {
    color: '#000000',
    size: '20',
};
